module.exports = __webpack_public_path__ + "img/8D.bdeedeb3.png";